<template>
  <div class="message">
    <img
      :src="`${config.publicPath}${image}`"
      :alt="altText"
      class="message__image"
      v-if="image"
    />
    <slot name="image" v-else></slot>
    <h1 class="message__title">{{ title }}</h1>
    <div class="message__content">
      <slot />
    </div>
    <div class="message__actions">
      <div class="message__action-slot">
        <slot name="action"></slot>
      </div>
      <SideWidget class="message__contact" v-if="needHelp">
        <template v-slot:label>Need help?</template>
        <template v-slot:action>
          <a :href="contactUrl || config.contactUsUrl">Contact Us</a>
        </template>
      </SideWidget>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import SideWidget from "@/modules/ui/SideWidget.vue";
import { configService } from "@/services/config-service";

@Options({
  components: {
    SideWidget,
  },
  props: {
    image: String,
    title: String,
    altText: String,
    contactUrl: String,
    needHelp: {
      type: Boolean,
      default: true,
    },
  },
})
export default class MessageLayout extends Vue {
  config = configService;
}
</script>

<style lang="scss" scoped>
.message {
  max-width: 480px;
  margin: 10px auto;

  &__action-slot {
    margin-bottom: 28px;
  }

  &__title {
    font-size: 36px;
    font-weight: 700;
    margin: 15px 0;
  }

  &__image {
    min-width: 150px;
    margin: 5px auto 38px;
    display: block;
  }

  &__content {
    font-size: 20px;
    line-height: 36px;
    word-break: break-word;
    margin-bottom: 60px;
  }

  &__contact {
    margin-top: 14px;
  }
}
</style>
